import { useCallback, useRef } from 'react';
import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { Waypoint } from '#src/app/shared/components/scroll';

import type { TipCardConfig } from '../types';

export const TipCard: React.FC<{ tip: TipCardConfig }> = ({ tip }) => {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const track = useTracking();
	const viewTracked = useRef(false);
	const trackView = useCallback(() => {
		if (viewTracked.current) return;
		void track('petition_strength_card_view', {
			petition_id: id,
			card: tip.type,
		});
		viewTracked.current = true;
	}, [id, track, tip.type, viewTracked]);

	return (
		<div className="bg-background-base flex h-full w-[325px] flex-col gap-2 rounded-md p-6">
			<Text as="p" size="small" fontWeight="bold">
				<TypedTranslate value={tip.title} />
			</Text>
			<Text as="p" size="small" className="text-typography-weak">
				<TypedTranslate value={tip.body} />
			</Text>
			<Text as="p" size="small">
				{tip.url ? (
					<Link href={tip.url} onClick={tip.onClick} preventScrollReset variant="primary">
						<TypedTranslate value={tip.primaryActionText} />
					</Link>
				) : (
					<Link as="button" type="button" onClick={tip.onClick} variant="primary">
						<TypedTranslate value={tip.primaryActionText} />
					</Link>
				)}
			</Text>
			<div className="flex">
				<div className="w-full" />
				<Waypoint horizontal onEnter={trackView} />
			</div>
		</div>
	);
};
